import React from 'react';
import defaultLocale from 'components/locale/defaultLocale';
import useStyles from './infoDisplay.styles';

type Props = {
  children?: JSX.Element;
  containerClass?: string;
  dataQa?: string;
  defaultValue?: string;
  label: string;
  labelClass?: string;
  value?: string | JSX.Element | null;
  valueClass?: string;
};

const InfoDisplay = ({
  children,
  containerClass,
  dataQa,
  defaultValue = defaultLocale['common.field.empty'],
  label,
  labelClass,
  value,
  valueClass
}: Props) => {
  const { container: defaultContainerClass, label: defaultLabelClass } = useStyles();

  return (
    <div className={containerClass || defaultContainerClass}>
      <p data-qa={`label-${dataQa}`} className={labelClass || defaultLabelClass}>
        {label}
      </p>
      <p data-qa={dataQa} className={valueClass}>
        {value || defaultValue}
      </p>
      {children}
    </div>
  );
};

export default InfoDisplay;
